export const options1 = [
    {
        value: '>',
        label: '>',
    },
    {
        value: '<',
        label: '<',
    },
    {
        value: '=',
        label: '=',
    },
    {
        value: '!=',
        label: '!=',
    },
]

export const options2 = [
    {
        value: '=',
        label: '=',
    },
    {
        value: '!=',
        label: '!=',
    },
]